import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

import {FacadeBaseModel} from '@shared/presentation/facade.base.model';

import {GetUsuryRateUseCase} from '@features/setting/application/use_cases/get-usury-rate/get-usury-rate.use-case';
import {
  GetUsuryRatePayloadDto
} from '@features/setting/application/use_cases/get-usury-rate/dto/get-usury-rate.payload.dto';
import {
  GetUsuryRateResponseDto
} from '@features/setting/application/use_cases/get-usury-rate/dto/get-usury-rate.response.dto';
import {finalize} from 'rxjs';

@Injectable({providedIn: 'root'})
export class GetUsuryRateFacade extends FacadeBaseModel<GetUsuryRateResponseDto | null> {

  private readonly destroyRef = inject(DestroyRef);
  private readonly useCase = inject(GetUsuryRateUseCase);

  constructor() {
    super(null);
  }

  public load(payload: GetUsuryRatePayloadDto): void {
    if (this.loading()) {
      return;
    }

    this.resetEvents();
    this.setLoading();

    this.useCase.execute(payload)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.setIdle())
      )
      .subscribe({
        next: (response) => {
          this.setData(response);
          this.setSuccess('Proceso exitoso!');
        },
        error: (error: unknown) => {
          this.setError(this.getErrorMessage(error));
        },
      });
  }

  public clear(): void {
    this.reset();
  }

}
